import { render, staticRenderFns } from "./qiyeConsult.vue?vue&type=template&id=965080f4&scoped=true&"
import script from "./qiyeConsult.vue?vue&type=script&lang=js&"
export * from "./qiyeConsult.vue?vue&type=script&lang=js&"
import style0 from "./qiyeConsult.vue?vue&type=style&index=0&id=965080f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965080f4",
  null
  
)

export default component.exports